import axios from 'axios';

const apiKIA = axios.create({
  baseURL: 'https://k-ia-backend.kintelligence.app.br'
  //baseURL: 'http://192.168.0.37:3347'
});

// Headers necessários para autenticação
apiKIA.defaults.headers.common['Content-Type'] = 'application/json';
apiKIA.defaults.headers.common['Authorization'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW4iOiJrLWludGVsaWdlbmNpYS1kYXNoYm9hcmQiLCJwdXJwb3NlIjoiSW50ZXJuYWwgQWRtaW4gVGVzdGluZyIsImdlbmVyYXRlZEF0IjoiMjAyNS0xMC0zMFQyMzoxOTowOS4wMjNaIiwiaWF0IjoxNzYxODY2MzQ5fQ.BH0z4CKKIMw5J6gFgYyM1stUddqC07geH3idXM3t72k';

export default apiKIA;